import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { ApiKey } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { ErrorAlert } from "@components/ErrorAlert";
import { queriesApiKeys } from "@query";

type Props = {
  apiKey: ApiKey;
} & WSModalCustomProps<boolean>;

const ModalDeleteApiKey: React.FC<Props> = props => {
  const [deleteApiKey, meta] = queriesApiKeys.deleteApiKey.useMutation();

  const handleDelete = async () => {
    await deleteApiKey(
      { apiKeyId: props.apiKey.id },
      { onSuccess: () => props.onClose(true) }
    );
  };

  return (
    <WSModal
      size="S"
      title={`Delete ${props.apiKey.name}?`}
      onClose={() => props.onClose(false)}
      actions={{
        buttons: [
          {
            label: "Cancel",
            kind: "Secondary",
            type: "button",
            onClick: () => props.onClose(false)
          },
          {
            label: "Delete",
            kind: "Primary",
            destructive: true,
            loading: meta.isLoading,
            onClick: handleDelete
          }
        ]
      }}
    >
      <WSList gap="M">
        <WSText>
          Any integration using this key will stop working. This action can't be
          undone.
        </WSText>
        <ErrorAlert context="ApiKeyDelete" error={meta.error} />
      </WSList>
    </WSModal>
  );
};

export const useModalDeleteApiKey = () => useWSModalCustom(ModalDeleteApiKey);
